import { Handle, Position } from "reactflow";
import { mdiFlagOutline } from "@mdi/js";
import Icon from "@mdi/react";

export default function StartEndNode({ data }) {
  const icon = (
    <div className="StartEndNodeIcon">
      <Icon path={mdiFlagOutline} size={0.8}></Icon>
    </div>
  );

  return (
    <div className="PlaybookNode">
      {!data.isStart ? (
        <Handle
          className="PlaybookHandle"
          type="target"
          position={Position.Top}
          isConnectable={false}
        />
      ) : (
        <></>
      )}

      <div style={{ display: "flex" }}>
        <div>{icon}</div>
        <div style={{ textAlign: "left", paddingRight: "5px" }}>
          <span className="PlaybookBlockLabel">
            {data.isStart ? <span>Start</span> : <span>End</span>}
          </span>
        </div>
      </div>

      {data.isStart ? (
        <Handle
          className="PlaybookHandle"
          type="source"
          position={Position.Bottom}
          id="a"
          isConnectable={false}
        />
      ) : (
        <></>
      )}
    </div>
  );
}
